export const EXCLUDED_PAYMENT_LABELS = [
  'credit card',
  'virtual card credit',
  'virtual card credit full return',
  'virtual card credit partial return'
];
export const EXCLUDED_PAYMENT_TYPES = [
    'creditCard'
];
export const FILTER_START_DATE = '2026-06-01';